export default __webpack_public_path__ + "static/media/default.65fdd800c86abc22ef11c28e80703923.png";